<template>
  <div class="dropdown-item">
    Diego assigned IR #1731 to you
    <br />
    <small>3 minutes ago</small>
  </div>
</template>

<script>
export default {
  name: "notifications"
};
</script>

<style scoped>
.dropdown-item:hover {
  background-color: #fff;
  cursor: auto;
}
</style>